import Dictionary from "./Dictionary";
import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="center">Tilde's dictionary</header>
        <Dictionary defaultKeyword="wonder" />
        <footer className="footer">Coded by Samantha Cabrera</footer>
      </div>
    </div>
  );
}

export default App;
